import React from 'react';
import { CheckIcon, LoaderIcon, ClipboardCheckIcon, CalendarIcon, InfoIcon, UserIcon, LinkIcon, MailIcon, PhoneIcon, MapPinIcon, HomeIcon } from 'lucide-react';
export const Step5Summary = ({
  formData,
  isSubmitting,
  isSubmitted
}) => {
  const renderJobTypes = () => {
    const selectedJobs = Object.entries(formData.jobTypes).filter(([key, value]) => value === true && key !== 'anders').map(([key]) => {
      switch (key) {
        case 'schilderwerk':
          return 'Schilderwerk';
        case 'stucwerk':
          return 'Stucwerk';
        case 'badkamerRenovatie':
          return 'Badkamer renovatie';
        case 'toiletRenovatie':
          return 'Toilet renovatie';
        case 'aanbouw':
          return 'Aanbouw';
        case 'completeWoningrenovatie':
          return 'Complete woningrenovatie';
        default:
          return key;
      }
    });
    if (formData.jobTypes.anders) {
      selectedJobs.push(`Anders: ${formData.jobTypes.andersText}`);
    }
    return selectedJobs.join(', ');
  };
  const renderSchilderwerkDetails = () => {
    if (!formData.jobTypes.schilderwerk) return null;
    const {
      schilderwerk
    } = formData;
    const specificaties = [];
    if (schilderwerk.specificaties.muren) specificaties.push(`Muren (${schilderwerk.murenM2} m²)`);
    if (schilderwerk.specificaties.plafonds) specificaties.push(`Plafonds (${schilderwerk.plafondsM2} m²)`);
    if (schilderwerk.specificaties.deuren) specificaties.push(`Deuren (${schilderwerk.deurenAantal || 0} stuks)`);
    if (schilderwerk.specificaties.kozijnen) specificaties.push(`Kozijnen (${schilderwerk.kozijnenAantal || 0} stuks)`);
    return <div className="mb-3" data-id="element-163">
        <p className="font-medium text-gray-800" data-id="element-164">Schilderwerk</p>
        <ul className="mt-1 space-y-1 text-gray-600 text-sm" data-id="element-165">
          {schilderwerk.leeftijdWoning && <li data-id="element-166">Leeftijd woning: {schilderwerk.leeftijdWoning}</li>}
          {specificaties.length > 0 && <li data-id="element-167">Specificatie: {specificaties.join(', ')}</li>}
        </ul>
      </div>;
  };
  const renderStucwerkDetails = () => {
    if (!formData.jobTypes.stucwerk) return null;
    const {
      stucwerk
    } = formData;
    const specificaties = [];
    if (stucwerk.specificaties.muren) specificaties.push(`Muren (${stucwerk.murenM2} m²)`);
    if (stucwerk.specificaties.plafonds) specificaties.push(`Plafonds (${stucwerk.plafondsM2} m²)`);
    return <div className="mb-3" data-id="element-168">
        <p className="font-medium text-gray-800" data-id="element-169">Stucwerk</p>
        <ul className="mt-1 space-y-1 text-gray-600 text-sm" data-id="element-170">
          {stucwerk.leeftijdWoning && <li data-id="element-171">Leeftijd woning: {stucwerk.leeftijdWoning}</li>}
          {specificaties.length > 0 && <li data-id="element-172">Specificatie: {specificaties.join(', ')}</li>}
        </ul>
      </div>;
  };
  const renderToiletRenovatieDetails = () => {
    if (!formData.jobTypes.toiletRenovatie) return null;
    const {
      toiletRenovatie
    } = formData;
    const wensen = [];
    if (toiletRenovatie.elektrischeVloerverwarming) wensen.push('Elektrische vloerverwarming');
    if (toiletRenovatie.nisInMuur) wensen.push('Nis in muur');
    if (toiletRenovatie.verlaagdPlafond) wensen.push('Verlaagd plafond');
    if (toiletRenovatie.inbouwWc) wensen.push('Inbouw wc');
    return <div className="mb-3" data-id="element-173">
        <p className="font-medium text-gray-800" data-id="element-174">Toilet renovatie</p>
        <ul className="mt-1 space-y-1 text-gray-600 text-sm" data-id="element-175">
          {wensen.length > 0 && <li data-id="element-176">Extra wensen: {wensen.join(', ')}</li>}
          {toiletRenovatie.oppervlakte && <li data-id="element-177">Oppervlakte: {toiletRenovatie.oppervlakte} m²</li>}
        </ul>
      </div>;
  };
  const renderBadkamerRenovatieDetails = () => {
    if (!formData.jobTypes.badkamerRenovatie) return null;
    const {
      badkamerRenovatie
    } = formData;
    const wensen = [];
    if (badkamerRenovatie.elektrischeVloerverwarming) wensen.push('Elektrische vloerverwarming');
    if (badkamerRenovatie.nisInDouche) wensen.push('Nis in douche');
    if (badkamerRenovatie.verlaagdPlafond) wensen.push('Verlaagd plafond');
    if (badkamerRenovatie.toiletinstallatie) wensen.push('Toiletinstallatie');
    return <div className="mb-3" data-id="element-178">
        <p className="font-medium text-gray-800" data-id="element-179">Badkamer renovatie</p>
        <ul className="mt-1 space-y-1 text-gray-600 text-sm" data-id="element-180">
          {wensen.length > 0 && <li data-id="element-181">Extra wensen: {wensen.join(', ')}</li>}
          {badkamerRenovatie.oppervlakte && <li data-id="element-182">Oppervlakte: {badkamerRenovatie.oppervlakte} m²</li>}
        </ul>
      </div>;
  };
  const renderCompleteWoningrenovatieDetails = () => {
    if (!formData.jobTypes.completeWoningrenovatie) return null;
    const {
      completeWoningrenovatie
    } = formData;
    const wensen = [];
    if (completeWoningrenovatie.keukeninstallatie) wensen.push('Keukeninstallatie');
    if (completeWoningrenovatie.isolatie) wensen.push('Isolatie');
    if (completeWoningrenovatie.vloerverwarming) wensen.push('Vloerverwarming');
    if (completeWoningrenovatie.badkamerToiletRenovatie) wensen.push('Badkamer/toilet renovatie');
    if (completeWoningrenovatie.elektraInstallatie) wensen.push('Gehele nieuwe elektra installatie');
    if (completeWoningrenovatie.herinrichtenRuimtes) wensen.push('Herinrichten van ruimtes');
    return <div className="mb-3" data-id="element-183">
        <p className="font-medium text-gray-800" data-id="element-184">Complete woningrenovatie</p>
        <ul className="mt-1 space-y-1 text-gray-600 text-sm" data-id="element-185">
          {wensen.length > 0 && <li data-id="element-186">Extra wensen: {wensen.join(', ')}</li>}
          {completeWoningrenovatie.totaleOppervlakte && <li data-id="element-187">
              Totale oppervlakte: {completeWoningrenovatie.totaleOppervlakte} m²
            </li>}
        </ul>
      </div>;
  };
  const renderAanbouwDetails = () => {
    if (!formData.jobTypes.aanbouw) return null;
    const {
      aanbouw
    } = formData;
    let aanbouwTypeText = '';
    switch (aanbouw.aanbouwType) {
      case 'casco':
        aanbouwTypeText = 'Casco (Wordt kaal opgeleverd zonder enige afwerking)';
        break;
      case 'allin':
        aanbouwTypeText = 'All-in (Aflevering inclusief stuccen, schilderen en standaard elektriciteit)';
        break;
      case 'allin-extra':
        aanbouwTypeText = "All-in met extra's (Zoals: vloerverwarming, meer stopcontacten, overstek, buitenkraan)";
        break;
      default:
        aanbouwTypeText = aanbouw.aanbouwType || 'Niet gespecificeerd';
    }
    return <div className="mb-3" data-id="element-188">
        <p className="font-medium text-gray-800" data-id="element-189">Aanbouw</p>
        <ul className="mt-1 space-y-1 text-gray-600 text-sm" data-id="element-190">
          <li data-id="element-191">Aanbouwtype: {aanbouwTypeText}</li>
        </ul>
      </div>;
  };
  const renderAddress = () => {
    const {
      straat,
      huisnummer,
      toevoeging,
      postcode,
      plaats
    } = formData.contactDetails;
    const hasAddress = straat || huisnummer || postcode || plaats;
    if (!hasAddress) return null;
    return <div className="mb-4" data-id="element-192">
        <p className="font-medium text-gray-800" data-id="element-193">Adresgegevens</p>
        <p className="text-gray-700 mt-1" data-id="element-194">
          {straat} {huisnummer}
          {toevoeging ? `-${toevoeging}` : ''}
          <br data-id="element-195" />
          {postcode} {plaats}
        </p>
      </div>;
  };
  return <div data-id="element-196">
      <div className="mb-4" data-id="element-197">
        <p className="text-gray-600 text-xs" data-id="element-198">
          Controleer uw gegevens voordat u de offerte aanvraagt.
        </p>
      </div>
      <div className="space-y-4" data-id="element-199">
        {/* Type opdracht section */}
        <div className="border border-gray-200 rounded-md p-3" data-id="element-200">
          <div className="flex items-center mb-1.5" data-id="element-201">
            <ClipboardCheckIcon className="h-3.5 w-3.5 text-[#FCCA86] mr-1.5" data-id="element-202" />
            <h3 className="text-sm font-semibold text-gray-800" data-id="element-203">
              Type opdracht
            </h3>
          </div>
          <p className="text-gray-700 text-xs" data-id="element-204">{renderJobTypes()}</p>
        </div>
        {/* Specificaties section */}
        <div className="border border-gray-200 rounded-md p-3" data-id="element-205">
          <div className="flex items-center mb-1.5" data-id="element-206">
            <ClipboardCheckIcon className="h-3.5 w-3.5 text-[#FCCA86] mr-1.5" data-id="element-207" />
            <h3 className="text-sm font-semibold text-gray-800" data-id="element-208">
              Specificaties
            </h3>
          </div>
          <div className="text-xs" data-id="element-209">
            {renderSchilderwerkDetails()}
            {renderStucwerkDetails()}
            {renderToiletRenovatieDetails()}
            {renderBadkamerRenovatieDetails()}
            {renderCompleteWoningrenovatieDetails()}
            {renderAanbouwDetails()}
          </div>
        </div>
        {/* Project info section */}
        <div className="border border-gray-200 rounded-md p-3" data-id="element-210">
          <div className="flex items-center mb-1.5" data-id="element-211">
            <InfoIcon className="h-3.5 w-3.5 text-[#FCCA86] mr-1.5" data-id="element-212" />
            <h3 className="text-sm font-semibold text-gray-800" data-id="element-213">
              Projectinformatie
            </h3>
          </div>
          <div className="space-y-2 text-xs" data-id="element-214">
            {formData.projectInfo.gewensteUitvoerdatum && <div className="flex" data-id="element-215">
                <CalendarIcon className="h-3.5 w-3.5 text-gray-500 mt-0.5 mr-1.5 flex-shrink-0" data-id="element-216" />
                <div data-id="element-217">
                  <span className="text-gray-700" data-id="element-218">Gewenste uitvoerdatum:</span>
                  <span className="ml-1" data-id="element-219">
                    {formData.projectInfo.gewensteUitvoerdatum}
                  </span>
                </div>
              </div>}
            {formData.projectInfo.projectOmschrijving && <div className="flex" data-id="element-220">
                <InfoIcon className="h-3.5 w-3.5 text-gray-500 mt-0.5 mr-1.5 flex-shrink-0" data-id="element-221" />
                <div data-id="element-222">
                  <span className="text-gray-700" data-id="element-223">Projectomschrijving:</span>
                  <p className="mt-1 text-gray-600" data-id="element-224">
                    {formData.projectInfo.projectOmschrijving}
                  </p>
                </div>
              </div>}
            {formData.projectInfo.linkNaarFotos && <div className="flex" data-id="element-225">
                <LinkIcon className="h-3.5 w-3.5 text-gray-500 mt-0.5 mr-1.5 flex-shrink-0" data-id="element-226" />
                <div data-id="element-227">
                  <span className="text-gray-700" data-id="element-228">Link naar foto's:</span>
                  <span className="ml-1 break-all" data-id="element-229">
                    {formData.projectInfo.linkNaarFotos}
                  </span>
                </div>
              </div>}
            {!formData.projectInfo.gewensteUitvoerdatum && !formData.projectInfo.projectOmschrijving && !formData.projectInfo.linkNaarFotos && <p className="text-gray-500 italic" data-id="element-230">
                  Geen projectinformatie opgegeven
                </p>}
          </div>
        </div>
        {/* Contact section */}
        <div className="border border-gray-200 rounded-md p-3" data-id="element-231">
          <div className="flex items-center mb-1.5" data-id="element-232">
            <UserIcon className="h-3.5 w-3.5 text-[#FCCA86] mr-1.5" data-id="element-233" />
            <h3 className="text-sm font-semibold text-gray-800" data-id="element-234">
              Contactgegevens
            </h3>
          </div>
          <div className="space-y-2 text-xs" data-id="element-235">
            <div className="flex" data-id="element-236">
              <UserIcon className="h-3.5 w-3.5 text-gray-500 mt-0.5 mr-1.5 flex-shrink-0" data-id="element-237" />
              <div data-id="element-238">
                <span className="text-gray-700" data-id="element-239">Naam:</span>
                <span className="ml-1" data-id="element-240">{formData.contactDetails.naam}</span>
              </div>
            </div>
            <div className="flex" data-id="element-241">
              <MapPinIcon className="h-3.5 w-3.5 text-gray-500 mt-0.5 mr-1.5 flex-shrink-0" data-id="element-242" />
              <div data-id="element-243">
                <span className="text-gray-700" data-id="element-244">Adres:</span>
                <p className="mt-0.5 text-gray-600" data-id="element-245">
                  {formData.contactDetails.straat}{' '}
                  {formData.contactDetails.huisnummer}
                  {formData.contactDetails.toevoeging && `-${formData.contactDetails.toevoeging}`}
                  <br data-id="element-246" />
                  {formData.contactDetails.postcode}{' '}
                  {formData.contactDetails.plaats}
                </p>
              </div>
            </div>
            <div className="flex" data-id="element-247">
              <MailIcon className="h-3.5 w-3.5 text-gray-500 mt-0.5 mr-1.5 flex-shrink-0" data-id="element-248" />
              <div data-id="element-249">
                <span className="text-gray-700" data-id="element-250">E-mailadres:</span>
                <span className="ml-1" data-id="element-251">
                  {formData.contactDetails.emailadres}
                </span>
              </div>
            </div>
            <div className="flex" data-id="element-252">
              <PhoneIcon className="h-3.5 w-3.5 text-gray-500 mt-0.5 mr-1.5 flex-shrink-0" data-id="element-253" />
              <div data-id="element-254">
                <span className="text-gray-700" data-id="element-255">Telefoonnummer:</span>
                <span className="ml-1" data-id="element-256">
                  {formData.contactDetails.telefoonnummer}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};